import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ExternalCashTransferStore, ExternalCashTransferState } from './external-cash-transfer.store';
import { Observable } from 'rxjs';
import { ExternalCashTransferViewModel } from './models/external-cash-transfer-view.model';

@Injectable({ providedIn: 'root' })
export class ExternalCashTransferQuery extends QueryEntity<ExternalCashTransferState> {
  constructor(protected store: ExternalCashTransferStore) {
    super(store);
  }

  /** Select the last TransferAccounts */
  selectTransferAccounts(): Observable<ExternalCashTransferViewModel | undefined> {
    return this.selectLast();
  }
}
